//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { CertiniaTask } from '@apis/campaign-requests/sampling/campaigns/certiniaTasksApiModel';
import { Serialized } from '@utils/types/Serialized';

export const deserializeCertiniaTask = (
  task: Serialized<CertiniaTask>,
): CertiniaTask => ({
  ...task,
  dueDate: task.dueDate ? new Date(task.dueDate) : undefined,
  lastActivityDate: task.lastActivityDate
    ? new Date(task.lastActivityDate)
    : undefined,
});
